import { useContext } from "react";
import { TranslationsContext } from "../providers/translations";

const useLocale = () => {
  const { locale } = useContext(TranslationsContext);
  return locale;
};

export default useLocale;
